"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeFormType = void 0;
var EmployeeFormType;
(function (EmployeeFormType) {
    EmployeeFormType["AG_LINE_OF_CREDIT"] = "AGRICULTURALLINEOFCREDIT";
    EmployeeFormType["AG_PURCHASE_EQUIPMENT"] = "AGRICULTURALPURCHASEEQUIPMENT";
    EmployeeFormType["AG_REFINANCE_PROPERTY"] = "AGRICULTURALREFINANCEPROPERTY";
    EmployeeFormType["AG_PURCHASE_ACREAGE"] = "AGRICULTURALPURCHASEACREAGE";
    EmployeeFormType["AUTOLOAN"] = "AUTOLOAN";
    EmployeeFormType["AUTOPREQUAL"] = "AUTOPREQUAL";
    EmployeeFormType["COMMERCIAL"] = "COMMERCIAL";
    EmployeeFormType["COMMERCIAL_BRIDGE_LOAN"] = "COMMERCIAL_BRIDGE_LOAN";
    EmployeeFormType["COMMERCIAL_EQUIPMENT"] = "COMMERCIAL_EQUIPMENT";
    EmployeeFormType["COMMERCIAL_PURCHASE"] = "COMMERCIAL_PURCHASE";
    EmployeeFormType["COMMERCIAL_REFINANCE"] = "COMMERCIAL_REFINANCE";
    EmployeeFormType["COMMERCIAL_RENEW"] = "COMMERCIAL_RENEW";
    EmployeeFormType["COMMERCIAL_VEHICLE"] = "COMMERCIAL_VEHICLE";
    EmployeeFormType["CONSTRUCTION"] = "CONSTRUCTION";
    EmployeeFormType["CONTACT"] = "CONTACT";
    EmployeeFormType["CREDITBOOSTER"] = "CREDITBOOSTER";
    EmployeeFormType["CREDITCARD"] = "CREDITCARD";
    EmployeeFormType["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
    EmployeeFormType["HOMEEQUITY"] = "HOMEEQUITY";
    EmployeeFormType["HOMEEQUITYEXPRESS"] = "HOMEEQUITYEXPRESS";
    EmployeeFormType["HOMEEQUITYLONGFORM"] = "HOMEEQUITYLONGFORM";
    EmployeeFormType["LAND"] = "LAND";
    EmployeeFormType["LONGFORM"] = "LONGFORM";
    EmployeeFormType["OTHERVEHICLE"] = "OTHERVEHICLE";
    EmployeeFormType["OVERDRAFTPROTECTION"] = "OVERDRAFTPROTECTION";
    EmployeeFormType["PERSONALLOAN"] = "PERSONALLOAN";
    EmployeeFormType["PURCHASETURBO"] = "PURCHASETURBO";
    EmployeeFormType["REFINANCETURBO"] = "REFINANCETURBO";
    EmployeeFormType["SBLINEOFCREDIT"] = "SBLINEOFCREDIT";
    EmployeeFormType["SBTERM"] = "SBTERM";
    EmployeeFormType["SHORTFORMPURCHASE"] = "SHORTFORMPURCHASE";
    EmployeeFormType["SHORTFORMREFINANCE"] = "SHORTFORMREFINANCE";
    EmployeeFormType["REVERSE"] = "REVERSE";
})(EmployeeFormType = exports.EmployeeFormType || (exports.EmployeeFormType = {}));
